import styled from "styled-components";

export const OptionsContainer = styled.div`
  position: absolute;
  top: 55px;
  right: 65px;
  background: var(--color-bg);
  border-color: red;
  display: flex;
  align-items: center;
  flex-direction: column;
  padding: 10px;
  border-radius: 8px;
  z-index: 9999;
  width: 110px;
  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.3);
`;

export const OptionItem = styled.p<{ danger?: boolean }>`
  margin: ${({ danger }) => (danger ? "0" : "0 0 10px 0")};
  color: ${({ danger }) => (danger ? "var(--color-invalid)" : "var(--color-text-primary)")};
  cursor: pointer;
  display: flex;
  align-items: center;

  &:hover {
    opacity: 0.9;
  }
`;
